import React, { useState, useEffect } from 'react'
import { useTrans } from 'hooks'
import { INDIRIZZI_FATTURAZIONE, INDIRIZZI_SPEDIZIONE } from 'utils/queries'
import { gql, useQuery } from '@apollo/client'
import { Mail } from 'components/atoms/Icons'
import { MyAccountIndirizziBlock } from 'components/molecules'
import { MyAccountPage, MyAccountIndirizzoCard } from 'components/organisms'

interface Props {
  pagina?: any
}

const MyAccountIndirizziTemplate = (props: Props) => {
  const { pagina = null } = props

  const [indirizziSpedizione, setIndirizziSpedizione] = useState([])
  const [indirizziFatturazione, setIndirizziFatturazione] = useState([])
  const { data: indirizziSpedizioneData } = useQuery(gql`${INDIRIZZI_SPEDIZIONE}`)
  const { data: indirizziFatturazioneData } = useQuery(gql`${INDIRIZZI_FATTURAZIONE}`)
  const t = useTrans()

  useEffect(() => {
    if (indirizziSpedizioneData?.indirizzi)
      setIndirizziSpedizione(indirizziSpedizioneData.indirizzi.edges.map(({ node }) => node))
  }, [indirizziSpedizioneData])

  useEffect(() => {
    if (indirizziFatturazioneData?.indirizzi)
      setIndirizziFatturazione(indirizziFatturazioneData.indirizzi.edges.map(({ node }) => node))
  }, [indirizziFatturazioneData])

  return (
    <MyAccountPage pagina={{ titolo: pagina?.titolo, descrizione: pagina?.descrizione, icon: <Mail /> }} activeMenuKey="indirizzi">
      <MyAccountIndirizziBlock titolo={t('Indirizzi di spedizione')}>
        {indirizziSpedizione.map((indirizzo, index) => (
          <MyAccountIndirizzoCard key={index} indirizzo={indirizzo} />
        ))}
      </MyAccountIndirizziBlock>

      <MyAccountIndirizziBlock titolo={t('Indirizzi di fatturazione')} fatturazione>
        {indirizziFatturazione.map((indirizzo, index) => (
          <MyAccountIndirizzoCard key={index} indirizzo={indirizzo} fatturazione />
        ))}
      </MyAccountIndirizziBlock>
    </MyAccountPage>
  )
}

export default MyAccountIndirizziTemplate
